import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
import Script from 'next/script';
import type { ExpertCtaStripBirdeyeConfig, ExpertCtaStripConfig } from './types';
import styles from './ExpertCtaStrip.module.css';
export interface ExpertCtaStripProps {
  config: ExpertCtaStripConfig;
  className?: string;
}
export function ExpertCtaStrip(t0) {
  const $ = _c(22);
  const {
    config,
    className
  } = t0;
  let t1;
  if ($[0] !== config.anchorId) {
    t1 = config.anchorId ? <span id={config.anchorId} className={styles.anchorTarget} aria-hidden="true" /> : null;
    $[0] = config.anchorId;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== className) {
    t2 = [styles.strip, className].filter(Boolean);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = t2.join(" ");
  let t4;
  if ($[4] !== config.caption || $[5] !== config.desktop || $[6] !== config.duplicateResponsivePhoneHeadings || $[7] !== config.phone) {
    t4 = <div className={styles.stripDesktop} data-cms-field="desktop" data-variant="desktop"><Inner birdeye={config.desktop} caption={config.caption} duplicateResponsivePhoneHeadings={config.duplicateResponsivePhoneHeadings} phone={config.phone} variant="desktop" /></div>;
    $[4] = config.caption;
    $[5] = config.desktop;
    $[6] = config.duplicateResponsivePhoneHeadings;
    $[7] = config.phone;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== config.caption || $[10] !== config.duplicateResponsivePhoneHeadings || $[11] !== config.mobile || $[12] !== config.phone) {
    t5 = <div className={styles.stripMobile} data-cms-field="mobile" data-variant="mobile"><Inner birdeye={config.mobile} caption={config.caption} duplicateResponsivePhoneHeadings={config.duplicateResponsivePhoneHeadings} phone={config.phone} variant="mobile" /></div>;
    $[9] = config.caption;
    $[10] = config.duplicateResponsivePhoneHeadings;
    $[11] = config.mobile;
    $[12] = config.phone;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== config.blockId || $[15] !== t3 || $[16] !== t4 || $[17] !== t5) {
    t6 = <section className={t3} data-cms-block-id={config.blockId}>{t4}{t5}</section>;
    $[14] = config.blockId;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== t1 || $[20] !== t6) {
    t7 = <>{t1}{t6}</>;
    $[19] = t1;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}
function Inner(t0) {
  const $ = _c(29);
  const {
    birdeye,
    caption,
    duplicateResponsivePhoneHeadings,
    phone,
    variant
  } = t0;
  const widgetDivId = `bf-revz-widget-${birdeye.widgetId}`;
  const scriptId = `birdeye-${variant}-${birdeye.widgetId}`;
  let t1;
  if ($[0] !== birdeye.scriptSrc || $[1] !== scriptId) {
    t1 = <Script id={scriptId} src={birdeye.scriptSrc} strategy="afterInteractive" />;
    $[0] = birdeye.scriptSrc;
    $[1] = scriptId;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== birdeye.attributionLink) {
    t2 = birdeye.attributionLink ? <a className="bf-pwr" href={birdeye.attributionLink.href} target="_blank" rel="noopener noreferrer">{birdeye.attributionLink.text}</a> : null;
    $[3] = birdeye.attributionLink;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t2 || $[6] !== widgetDivId) {
    t3 = <div id={widgetDivId}>{t2}</div>;
    $[5] = t2;
    $[6] = widgetDivId;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== birdeye.scriptSrc || $[9] !== t1 || $[10] !== t3 || $[11] !== widgetDivId) {
    t4 = <div className={styles.birdeyeCol} data-birdeye-script-src={birdeye.scriptSrc} data-birdeye-widget-id={widgetDivId}>{t1}{t3}</div>;
    $[8] = birdeye.scriptSrc;
    $[9] = t1;
    $[10] = t3;
    $[11] = widgetDivId;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== caption.lead) {
    t5 = <p className={styles.caption} data-cms-field="caption.lead">{caption.lead}</p>;
    $[13] = caption.lead;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <br />;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== caption.followUpAfter || $[17] !== caption.followUpBefore) {
    t7 = <p className={styles.caption} data-cms-field="caption.followUp">{caption.followUpBefore} {t6} {caption.followUpAfter}</p>;
    $[16] = caption.followUpAfter;
    $[17] = caption.followUpBefore;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== duplicateResponsivePhoneHeadings || $[20] !== phone) {
    t8 = duplicateResponsivePhoneHeadings ? <><PhoneHeading className={styles.phoneMobileOnly} phone={phone} /><PhoneHeading className={styles.phoneDesktopOnly} phone={phone} /></> : <PhoneHeading phone={phone} />;
    $[19] = duplicateResponsivePhoneHeadings;
    $[20] = phone;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  let t9;
  if ($[22] !== t5 || $[23] !== t7 || $[24] !== t8) {
    t9 = <div className={styles.contentCol}>{t5}{t7}{t8}</div>;
    $[22] = t5;
    $[23] = t7;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== t4 || $[27] !== t9) {
    t10 = <div className={styles.row}>{t4}{t9}</div>;
    $[26] = t4;
    $[27] = t9;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  return t10;
}
function PhoneHeading(t0) {
  const $ = _c(8);
  const {
    className,
    phone
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = [styles.phoneHeading, className].filter(Boolean);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = t1.join(" ");
  let t3;
  if ($[2] !== phone.href || $[3] !== phone.label) {
    t3 = <a href={phone.href} className={styles.phoneLink}>{phone.label}</a>;
    $[2] = phone.href;
    $[3] = phone.label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2 || $[6] !== t3) {
    t4 = <h3 className={t2} data-cms-field="phone">{t3}</h3>;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}